
export const PageType = {
    'Folder': 'Folder',
    'Image': 'Image',
    'Gallery': 'Gallery',
    'Text': 'Text',
};
